import { AppService } from '../main/app.service';

export class BaseService<TEntity> {

    public collection: Restangular.ICollection = null;

    public list: Array<TEntity>;
    public item: TEntity;

    constructor(protected Restangular: Restangular.IService, protected AppService: AppService, protected itemName?: string) {
        this.collection = Restangular.all(itemName);
    }

    public all = (): ng.IPromise<TEntity[]> => {
        return this.Restangular.all(this.itemName).getList().then((list: Restangular.ICollection) => {
            this.list = list;
            return list.plain();
        });
    }

    public get(id: string | number): ng.IPromise<TEntity> {
        if ((typeof id === "number" && id > 0) || (typeof id === "string" && ( id != undefined && id != 'new' ))) {
            return this.Restangular.one(this.itemName, id.toString()).get().then((item) => {
                this.item = item;
                return item.plain();
            });
        } else {
            this.item = null;
            return null;
        }
    }

    public delete(id: string | number): Restangular.IPromise<TEntity> {
         var promise = this.Restangular.one(this.itemName, id.toString()).remove();
         promise
            .then(result => {
                this.AppService.NotifyService.success('Verwijderd', 'De gegevens zijn verwijderd');
            })
            .catch(error => {
                this.AppService.NotifyService.error('Foutmelding', error);
            });
        return promise;
    }

    public post(data): ng.IPromise<TEntity> {
        return this.collection.post(data).then((item: Restangular.IElement) => {
            this.AppService.NotifyService.success('Opgeslagen', 'De gegevens zijn opgeslagen');
            return item.plain();
        })
        .catch((error) => {
            this.AppService.NotifyService.error('Foutmelding', error);
            return error;
        });
    }

    public put(id: string | number, data): Restangular.IPromise<TEntity> {
        var promise = this.Restangular.one(this.itemName, id.toString()).customPUT(data);
        promise
            .then(result => {
                this.AppService.NotifyService.success('Opgeslagen', 'De gegevens zijn opgeslagen');
            })
            .catch(error => {
                this.AppService.NotifyService.error('Foutmelding', error);
            });
        return promise;
    }

    public one(id: string | number = null): Restangular.IElement {
        if (id) {
            return this.Restangular.one(this.itemName, id.toString());
        } else {
            return this.Restangular.one(this.itemName);
        }
    }


    public listLoaded = (list: TEntity[]) => { 
        return list;
    }

    public itemLoaded = (item: TEntity) => { 
        return item;
    }

    public customAll = (url, params = null): ng.IPromise<TEntity[]> => {
    console.log(params);
    return this.Restangular.all(this.itemName + '/' + url).getList(params).then((list: Restangular.ICollection) => {
        this.list = list;
        return this.listLoaded(list.plain());
        });
    }
        public getChild(id: string | number, childName): ng.IPromise<TEntity> {
        if ((typeof id === "number" && id > 0) || (typeof id === "string" && ( id != undefined && id != 'new' ))) {
            return this.Restangular.one(this.itemName, id.toString()).customGET(childName).then((item) => {
                this.item = item;
                return item.plain();
            });
        } else {
            this.item = null;
            return null;
        }
    }
}


// WEBPACK FOOTER //
// ./~/@abosol/masterdata/src/base/base.service.ts